import { getExistingApiInstance } from '../api'
export default function useVacancies() {

  async function getVacanciesList(params) {
    const api = getExistingApiInstance()
    const res = await api.get('/vacancy?expand=sponsor', {
      params: params,
    })
    return {
      data: res.data.items,
      meta: res.data._meta
    }
  }
  async function getVacancies(idVacancies) {
    const api = getExistingApiInstance()
    const { data } = await api.get(`/vacancy/${idVacancies}?expand=sponsor`)
    return data
  }
  async function createVacancies(dataVacancies) {
    const api = getExistingApiInstance()
    const { data } = await api.post(`/vacancy`, dataVacancies)
    return data
  }
  async function getMyVacancies(params) {
    const api = getExistingApiInstance()
    const { data } = await api.get(`/partner?&expand=vacancies`, {
      params: params
    })
    return data
  }
  async function deleteVacancy(vacancyId) {
    const api = getExistingApiInstance()
    const { data } = await api.delete(`vacancy/${vacancyId}`)
    return data
  }
  async function updateVacancy(vacancyId, dataVacancies) {
    const api = getExistingApiInstance()
    const { data } = await api.patch(`vacancy/${vacancyId}`, dataVacancies)
    return data
  }

  return {
    updateVacancy,
    getVacanciesList,
    getVacancies,
    getMyVacancies,
    createVacancies,
    deleteVacancy
  }
}

